<table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
    <ng-container matColumnDef="personel">
        <th mat-header-cell *matHeaderCellDef>Personnel</th>
        <td mat-cell *matCellDef="let element">
            <ng-template [ngIf]="element.IsCovering">
                    {{ element.CoveringName }}
                    <app-covering-officer-chip
                  [originalPersonnelName]="element.PersonnelName"></app-covering-officer-chip>
            </ng-template>
            <ng-template [ngIf]="!element.IsCovering">{{ element.PersonnelName}}</ng-template>
        </td>
    </ng-container>

    <ng-container matColumnDef="appointment">
        <th mat-header-cell *matHeaderCellDef>Appointment</th>
        <td mat-cell *matCellDef="let element">
            {{ element.Appointment }}
        </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.Action }}</td>
    </ng-container>

    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">
            {{ element.Date | date : "dd/MM/yy" }}
        </td>
    </ng-container>

    <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">
            {{ element.Comment ?? "-" }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
